import { render, staticRenderFns } from "./ModalShowManagmentOptions.vue?vue&type=template&id=56a20da4"
import script from "./ModalShowManagmentOptions.vue?vue&type=script&lang=js"
export * from "./ModalShowManagmentOptions.vue?vue&type=script&lang=js"
import style0 from "./ModalShowManagmentOptions.vue?vue&type=style&index=0&id=56a20da4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports